/* global swal */
import './style.less';

export default function($scope, $log, $stateParams, $timeout, Swal, ApiClass, $state, $q) {
  'ngInject';

  const vm = this;
  vm.$onInit = activate;

  let correct;

  vm.loaded = false;
  vm.sorted = ['a', 'b', 'c', 'd'];

  vm.formData = {};
  vm.prev = () => $state.go('^.video', $stateParams);

  vm.reviewQuiz = function(answer) {
    const currentIndex = vm.course.modules.indexOf($stateParams.moduleId);
    const numModules = vm.course.modules.length;

    if (answer.toUpperCase() !== correct.toUpperCase()) {
      if (!vm.question.reasons || !vm.question.reasons[answer]) return swal('Incorrect', 'Incorrect Answer', 'error');
      return swal('Incorrect, try again', vm.question.reasons[answer], 'error');
    }

    return ApiClass.coursesIdTypeTypeIdPatch(
      { id: $stateParams.courseId, type: 'progress', type_id: $stateParams.id },
      { quiz: true, module_id: $stateParams.moduleId }
    )
      .then(progressResponse => {
        const data = progressResponse.data.progress;
        if ($scope.$parent.selfStudyCtrl && $scope.$parent.selfStudyCtrl.progress) {
          $scope.$parent.selfStudyCtrl.progress.modules_taken = data.modules_taken;
          $scope.$parent.selfStudyCtrl.progress.final = data.final;
          if ($scope.$parent.selfStudyCtrl.progress.modules) {
            $scope.$parent.selfStudyCtrl.progress.modules[$stateParams.moduleId].quiz = true;
          }
        }
        return Swal.alert('Correct!', vm.question.reasons[answer]).then(() => {
          if (currentIndex < numModules - 1) {
            let next = vm.course.modules[currentIndex + 1];
            $stateParams.moduleId = next;
            $state.go('^.video', { moduleId: next });
            $scope.$parent.selfStudyCtrl.activeModule = next;
          }
          if (data.final && currentIndex === numModules - 1) {
            $state.go('^.final', { $stateParams });
            $scope.$parent.selfStudyCtrl.activeModule = 'final';
          }
        });
      })
      .catch(error => {
        if (error.dismiss) return;
        $log.error(error);
        throw error;
      });
  };

  function activate() {
    $log.debug('Quiz Component Activated');
    vm.loaded = false;
    vm.error = {};

    ApiClass.coursesIdGet({ id: $stateParams.courseId }, {}, { queryParams: { updateProgress: true } })
      .then(courseResponse => {
        $log.debug('Quiz Component Data', arguments);
        vm.course = courseResponse.data.course;
        vm.index = vm.course.modules.indexOf($stateParams.moduleId);
        vm.question = vm.course.modulesArr[vm.index];
        correct = vm.course.modulesArr[vm.index].correct;
        vm.loaded = true;
      })
      .catch(error => {
        $log.error(error);
        vm.loaded = true;
        vm.error = { status: true, refresh: activate };
        throw error;
      });
  }
}



// WEBPACK FOOTER //
// ./src/app/components/selfStudy/quiz/controller.js